<template>
  <div class="history-container">
    <el-card class="header-container">
      <el-row align="middle" type="flex" :gutter="5" style="height: 50px">
        <i class="el-icon-back" @click="handleBack" />
        <img class="header-logo" src="~@/assets/images/logo-blue.png" @click="$router.push({ path: '/home' })" />
        <div class="publish_info" v-if="detailInfo">
          <span>第{{ detailInfo.no }}次发布 | </span>
          <span>
            {{
              detailInfo.inUse
                ? detailInfo.createTime + ' 至今 '
                : detailInfo.createTime + ' 至 ' + detailInfo.updateTime
            }}
          </span>
          <span> | {{ detailInfo.publisher }}</span>
        </div>
      </el-row>
    </el-card>
    <div class="content-container">
      <pre-view :detailUrl="`/user/form/release/id/${detailInfo.id}`" />
    </div>
  </div>
</template>

<script>
import PreView from '@/views/form/preview'
export default {
  name: 'HistoryDetail',
  components: { PreView },
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
    handleBack() {
      this.$emit('goBack')
    }
  }
}
</script>
<style lang="scss" scoped>
.history-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  .header-container {
    flex: 1;
    padding: 0 20px;
    .publish_info {
      margin-left: 75px;
      font-size: 18px;
      font-weight: 600;
    }
    .el-icon-back {
      font-size: 22px;
      font-weight: 550;
      cursor: pointer;
      color: #000;
      margin-right: 75px;

      &:hover {
        color: rgb(32, 160, 255);
      }
    }

    .header-logo {
      height: 35px;
      width: 35px;
      vertical-align: middle;
    }
  }
  .content-container {
    flex: 1;
  }
}
</style>
